import {MARKER, markerBodySvg} from "./markerIcon";

function esc(s) {
    return String(s == null ? "" : s)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
}
function shapeToSvg(sh) {
    if (sh.type === "rect") {
        return `<rect x="${sh.x}" y="${sh.y}" width="${sh.w}" height="${sh.h}" fill="none" stroke="#334155"/>`;
    }
    if (sh.type === "circle") {
        return `<circle cx="${sh.cx}" cy="${sh.cy}" r="${sh.r}" fill="none" stroke="#334155"/>`;
    }
    if (sh.type === "line") {
        const pts = sh.points.map(([x, y]) => `${x},${y}`).join(" ");
        return `<polyline points="${pts}" fill="none" stroke="#334155"/>`;
    }
    if (sh.type === "text") {
        return `<text x="${sh.x}" y="${sh.y}" font-size="14" fill="#334155">${esc(sh.value)}</text>`;
    }
    return "";
}
function markerToSvg(m, showLabels) {
    const s = m.scale || MARKER.DEFAULT_SCALE;
    const label = showLabels
        ? `<text y="${MARKER.LABEL_DY}" font-size="12" text-anchor="middle" fill="${MARKER.label}">${esc(m.label)}</text>`
        : "";
    return `<g class="turnstile-marker" data-turnstile-id="${m.turnstileId}" transform="translate(${m.x},${m.y}) scale(${s})">` +
        markerBodySvg() +
        label +
        `</g>`;
}
export function serializeScene(scene) {
    const {viewBox, shapes, markers} = scene;
    // Encode < and > as JSON unicode escapes so no literal ">" survives:
    // this both keeps the raw label text out of a naive "<tag>" substring
    // match (see serializeScene.test.js "escapuje speciální znaky v labelu")
    // and guarantees the CDATA terminator "]]>" can never appear inside the
    // embedded JSON. JSON.parse decodes </> back transparently.
    const json = JSON.stringify(scene)
        .replace(/</g, "\\u003C")
        .replace(/>/g, "\\u003E");
    const showLabels = scene.labels !== false;
    const shapesSvg = shapes.map(shapeToSvg).join("");
    const markersSvg = markers.map((m) => markerToSvg(m, showLabels)).join("");
    // Podklad = data URI sanitizovaného SVG, vykreslený jako <image> (secure static
    // mode prohlížeče, žádné skripty) pod vrstvami. href data URI neobsahuje ".
    const backgroundSvg = scene.background
        ? `<image class="layer-background" x="0" y="0" width="${viewBox.w}" height="${viewBox.h}" ` +
          `preserveAspectRatio="xMidYMid meet" opacity="0.6" href="${scene.background}"/>`
        : "";
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${viewBox.w} ${viewBox.h}">` +
        `<metadata><![CDATA[${json}]]></metadata>` +
        backgroundSvg +
        `<g class="layer-shapes">${shapesSvg}</g>` +
        `<g class="layer-markers">${markersSvg}</g>` +
        `</svg>`;
}
